import type { Kpi } from '../types';

export type Rag = 'achieved' | 'near' | 'off';

/** Parses the numeric part of a KPI display value ("1,840" -> 1840, "-2.1" -> -2.1). */
export function parseKpiValue(value: string): number {
  return parseFloat(value.replace(/[,\s]/g, ''));
}

/**
 * Attainment % against target (clamped 0–120).
 * direction 'up'  : current / target
 * direction 'down': target / current  (lower is better)
 * `target.progress` overrides the computation for non-ratio cases.
 */
export function attainment(kpi: Kpi): number | undefined {
  const t = kpi.target;
  if (!t) return undefined;
  if (typeof t.progress === 'number') return clamp(t.progress);
  const current = parseKpiValue(kpi.value);
  if (!isFinite(current) || current <= 0 || t.value <= 0) return undefined;
  const pct = t.direction === 'up' ? (current / t.value) * 100 : (t.value / current) * 100;
  return clamp(pct);
}

export function ragFor(pct: number): Rag {
  if (pct >= 100) return 'achieved';
  if (pct >= 90) return 'near';
  return 'off';
}

function clamp(pct: number): number {
  return Math.max(0, Math.min(120, Math.round(pct)));
}
